<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.col.colCode']">
              <a-input  v-model="queryParam.colCode" allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['emp.col.colName']">
              <a-input  v-model="queryParam.colName" allow-clear></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['emp.col.templateType']">
                <j-dict-select-tag  v-model="queryParam.templateType" dictCode="hhemp_template_type" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['emp.col.publishStatus']">
                <j-dict-select-tag  v-model="queryParam.publishStatus" dictCode="hhemp_publish_status" allow-clear/>
              </a-form-item>
            </a-col>
            <!--            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                          <a-form-item label="发布时间">
                            <j-date placeholder="请选择发布时间" v-model="queryParam.publishTime"></j-date>
                          </a-form-item>
                        </a-col>-->
            <!--            <a-col :xl="10" :lg="11" :md="8" :sm="24">
                          <a-form-item label="发布时间">
                            <j-date placeholder="请选择开始日期" v-model="queryParam.publishTimeStart" allowClear></j-date>
                            <span class="query-group-split-cust"></span>
                            <j-date placeholder="请选择开始日期" v-model="queryParam.publishTimeEnd" allowClear></j-date>
                          </a-form-item>
                        </a-col>-->
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button @click="handleAdd" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>-->
      <!--      <a-button type="primary" icon="download" @click="handleExportXls('cms_col_tbl')">导出</a-button>
            <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
              <a-button type="primary" icon="import">导入</a-button>
            </a-upload>-->
      <!-- 高级查询区域 -->
      <!--<j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @expand="expand"
        @expandedRowsChange="expandedRowsChange"
        :expandedRowKeys="expandedRowKeys"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <!--@expand="expand"
        @expandedRowsChange="expandedRowsChange"
        :expandedRowKeys="expandedRowKeys"-->
        <!--<template #expandedRowRender>
          <a-table :columns="innerColumns" :data-source="innerData" :pagination="false">
          </a-table>
        </template>-->
        <!--<template #expandedRowRender=" record,index, indent, expanded " v-show="record.colLevel=='1'">
          <a-table :columns="innerColumns" :data-source="innerData" ref="table" size="middle" :scroll="{x:true}" bordered rowKey="id" :pagination="false">
            <span slot="innerAction" slot-scope="innerText, innerRecord">
              <a @click="handleContentList(innerRecord)" v-if="innerRecord.colLevel == '2'||(innerRecord.colLevel=='1'&&innerRecord.templateType=='2')">内容列表</a>
              <a @click="addChildren(innerRecord)" v-if="innerRecord.colLevel == '1'&&innerRecord.templateType=='1'&&innerRecord.childNumber<=5">增加分类</a>
              <a-divider type="vertical"  />
              <a @click="handleApplication(innerRecord)">应用</a>
              <a-divider type="vertical" />
              <a @click="handleEdit(innerRecord)">编辑</a>
              <a-divider type="vertical" />
              <a @click="publish(innerRecord)" v-if="innerRecord.publishStatus=='unpublished'">上架</a>
              <a @click="unpublish(innerRecord)" v-if="innerRecord.publishStatus=='published'">下架</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="handleDetail(innerRecord)">详情</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(innerRecord.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
        </template>-->

        <span slot="action" slot-scope="text, record">
          <a @click="handleContentList(record)" v-has="'cmscontent:contentList'"
             v-if="(record.topTemplateType == '1'&&record.colLevel=='2')//服务公告模版
             ||(record.topTemplateType == '2'&&record.colLevel=='1')//教育训练专区模版
             ||(record.topTemplateType == '3'&&record.colLevel=='2')//常见问题模版
             ||(record.topTemplateType == '4'&&record.colLevel=='2')//资源与下载模版
             ||(record.topTemplateType == '5'&&record.colLevel=='1')//精选服务模版
             ||(record.topTemplateType == '6'&&record.colLevel=='2')//关于我们模版
             ||(record.topTemplateType == '7'&&record.colLevel=='1')//为你推荐模版
             ||(record.topTemplateType == '8'&&record.colLevel=='3')//文件管理模版
             //模版九
             ||(record.topTemplateType == '9'&&record.colLevel=='2')"
          >{{language['emp.col.contentTab']}}</a>
          <a-divider type="vertical"  v-has="'cmscontent:contentList'"
                     v-if="(record.topTemplateType == '1'&&record.colLevel=='2')//服务公告模版
                       ||(record.topTemplateType == '2'&&record.colLevel=='1')//教育训练专区模版
                       ||(record.topTemplateType == '3'&&record.colLevel=='2')//常见问题模版
                       ||(record.topTemplateType == '4'&&record.colLevel=='2')//资源与下载模版
                       ||(record.topTemplateType == '5'&&record.colLevel=='1')//精选服务模版
                       ||(record.topTemplateType == '6'&&record.colLevel=='2')//关于我们模版
                       ||(record.topTemplateType == '7'&&record.colLevel=='1')//为你推荐模版
                       ||(record.topTemplateType == '8'&&record.colLevel=='3')//文件管理模版
                       //模版九
                       ||(record.topTemplateType == '9'&&record.colLevel=='2')"/>
          <a @click="handleDetail(record)" v-has="'cmscontent:coldetail'"  >{{language['common.detailsButton']}}</a>
          <!--<a @click="addChildren(record)" v-if="record.colLevel == '1'&&record.templateType=='1'&&record.childNumber<=5">{{language['emp.col.addClassification']}}</a>
          <a-divider type="vertical"  />-->
        </span>

        <span slot="colLevel" slot-scope="text,record">
          <span v-if="record.colLevel == '1'">{{language['emp.col.colLevel_one']}}</span>
          <span v-else>{{language['emp.col.colLevel_two']}}</span>
        </span>

      </a-table>
    </div>

    <cms-col-tbl-modal ref="modalForm" @ok="searchQuery"></cms-col-tbl-modal>
    <cms-col-tbl-children-modal ref="childrenModalFrom" @ok="searchQuery"/>
    <cms-content-tbl-list-modal ref="listModal" @ok="searchQuery"></cms-content-tbl-list-modal>
    <cms-col-application-model ref="applicationModel" @ok="searchQuery"></cms-col-application-model>
  </a-card>
</template>

<script>

import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import CmsColTblModal from './modules/CmsColTblModal'
import CmsColTblChildrenModal from './modules/CmsColTblChildrenModal'
import { getAction } from '@/api/manage'
import CmsContentTblListModal from './modules/CmsContentTblListModal'
import CmsColApplicationModel from './modules/CmsColApplicationModel'
import { filterDictText } from '@/components/dict/JDictSelectUtil'
import { getDictItemsFromCache } from '@/api/api'

export default {
  name: 'CmsContentTblPublishList',
  mixins:[JeecgListMixin, mixinDevice],
  components: {
    CmsColTblModal,
    CmsColTblChildrenModal,
    CmsContentTblListModal,
    CmsColApplicationModel
  },
  data () {
    return {
      innerColumns:[
        {
          title:'栏目名称',
          align:"left",
          dataIndex: 'colName'
        },
        {
          title:'编号',
          align:"center",
          dataIndex: 'colCode'
        },
        {
          title:'地区',
          align:"center",
          dataIndex: 'entrance.entranceName'
        },
        {
          title:'发布人',
          align:"center",
          dataIndex: 'publisher',
          customRender:function (text,record){
            if(record.publishStatus == 'published'){
              return  text
            }else{
              return ""
            }
          }
        },
        {
          title:'发布时间',
          align:"center",
          dataIndex: 'publishTime',
          customRender:function (text,record) {
            if(record.publishStatus == 'published'){
              return !text?"":(text.length>19?text.substr(0,19):text)
            }else{
              return "";
            }
          }
        },
        {
          title:'发布状态',
          align:"center",
          dataIndex: 'publishStatusName'
        },
        {
          title:'內容数（分类数）',
          align:"center",
          dataIndex: 'contentNumber',
          customRender:function (text,r) {
            if(r.childNumber>0){
              return r.childNumber
            }else{
              return text
            }
          }
        },
        {
          title:'排序',
          align:"center",
          dataIndex: 'sortNo'
        },
        {
          title:'备注',
          align:"center",
          dataIndex: 'remark',
        },
        {
          title: '操作',
          dataIndex: 'innerAction',
          align:"center",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      innerData:[],

      description: 'cms_col_tbl管理页面',
      expandedRowKeys:[],
      // 表头
      columns: [
        /*{
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },*/
        {
          title:this.$store.getters.language['emp.col.colName'],
          align:"center",
          dataIndex: 'colName',
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title:this.$store.getters.language['emp.col.colCode'],
          align:"center",
          dataIndex: 'colCode'
        },
        {
          title:this.$store.getters.language['emp.col.entrance.entranceName'],
          align:"center",
          dataIndex: 'entrance.entranceName',
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title:this.$store.getters.language['emp.col.colLevel'],
          align:"center",
          dataIndex: 'colLevel',
          scopedSlots:{ customRender: 'colLevel' },
          /*customRender:function (text,record){
            if(record.colLevel == '1'){
              return this.$store.getters.language['emp.col.colLevel_one']
            }else{
              return this.$store.getters.language["emp.col.colLevel_two"]
            }
          }*/
        },
        /*{
          title:this.$store.getters.language['emp.col.templateTypeName'],
          align:"center",
          dataIndex: 'templateTypeName',
        },*/
        {
          title:this.$store.getters.language['emp.col.publisher'],
          align:"center",
          dataIndex: 'publisher',
          customRender:function (text,record){
            if(record.publishStatus == 'published'){
              return  text
            }else{
              return ""
            }
          }
        },
        {
          title:this.$store.getters.language['emp.col.publishTime'],
          align:"center",
          dataIndex: 'publishTime',
          customRender:function (text,record) {
            if(record.publishStatus == 'published'){
              return !text?"":(text.length>19?text.substr(0,19):text)
            }else{
              return "";
            }
          }
        },
        /*{
          title:'发布应用',
          align:"center",
          dataIndex: 'publishApplications'
        },*/
        {
          title:this.$store.getters.language['emp.col.publishStatusName'],
          align:"center",
          dataIndex: 'publishStatusName'
        },
        {
          title:this.$store.getters.language['emp.col.contentNumber'],
          align:"center",
          dataIndex: 'contentNumber',
          customRender:function (text,r) {
            if(r.childNumber>0){
              return r.childNumber
            }else{
              return text
            }
          }
        },
        {
          title:this.$store.getters.language['emp.col.sortNo'],
          align:"center",
          dataIndex: 'sortNo'
        },
        /* {
           title:'刪除标示',
           align:"center",
           dataIndex: 'delFlag'
         },*/
        {
          title:this.$store.getters.language['emp.col.remark'],
          align:"center",
          dataIndex: 'remark',
          customCell: () => {
            return {
              style: {
                'text-align': 'left'
              },
            };
          },
        },
        {
          title: this.$store.getters.language['common.action'],
          dataIndex: 'action',
          align:"center",
          // fixed:"right",
          width:147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: "/hhemp/col/cmscoltbls?publishStatus=published",
        delete: "/hhemp/col/cmscoltbl",
        deleteBatch: "/hhemp/col/cmscoltbl/batch",
        exportXlsUrl: "/hhemp/col/export-xls",
        importExcelUrl: "hhemp/col/import-excel",
        publish: "/hhemp/col/publishstatus",

      },
      dictOptions:{},
      superFieldList:[],
    }
  },
  created() {
    this.getSuperFieldList();
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    language() {
      return this.$store.getters.language
    },
    /*tableProps() {
      let _this = this
      return {
        // 列表项是否可选择
        rowSelection: {
          selectedRowKeys: _this.selectedRowKeys,
          onChange: (selectedRowKeys) => _this.selectedRowKeys = selectedRowKeys
        }
      }
    }*/
  },
  methods: {
    handleDetail(record){
      record.flag = 'detail'

      if(record.colLevel == '1'){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title=this.language['common.detailsButton'];
        this.$refs.modalForm.disableSubmit = true;
      }else if(record.colLevel == '2'){
        this.$refs.childrenModalFrom.edit(record);
        this.$refs.childrenModalFrom.title=this.language['common.detailsButton'];
        this.$refs.childrenModalFrom.disableSubmit = true;
      }
    },
    searchQuery(){
      this.expandedRowKeys = []
      this.loadData(1);
    },
    searchReset() {
      //重置
      this.expandedRowKeys = []
      this.queryParam = {}
      this.loadData(1);
    },
    expandedRowsChange(expandedRows){
      this.expandedRowKeys = expandedRows
    },
    expand(expanded,record){
      if(expanded){
        // this.expandedRowKeys.push(record);
        getAction("/hhemp/col/getChildrenCmscoltbls",{parentColId:record.id,publishStatus:'published'}).then(res=>{
          if(res.success){
            // this.expandedRowKeys = [record.id]
            record.children = res.result;
            // this.innerData = [res.result];
          }
        })
      }else{
        // this.expandedRowKeys = []
        // this.innerData = [];
      }
    },
    addChildren(record){
      this.$refs.childrenModalFrom.title = this.language["common.insertButton"]
      this.$refs.childrenModalFrom.add(record);
    },
    handleAdd(){
      this.$refs.modalForm.title = this.language["common.insertButton"]
      this.$refs.modalForm.add();
    },
    handleEdit(record){
      if(record.colLevel == '1'){
        this.$refs.modalForm.title = this.language["common.edit"]
        this.$refs.modalForm.edit(record);
      }else if(record.colLevel == '2'){
        this.$refs.childrenModalFrom.title = this.language["common.edit"]
        this.$refs.childrenModalFrom.edit(record);
      }
    },
    initDictConfig(){
    },
    getSuperFieldList(){
      let fieldList=[];
      fieldList.push({type:'string',value:'colCode',text:'栏位编号',dictCode:''})
      fieldList.push({type:'string',value:'colName',text:'栏位名称',dictCode:''})
      fieldList.push({type:'string',value:'templateType',text:'模板类型',dictCode:''})
      fieldList.push({type:'string',value:'publishStatus',text:'发布状态',dictCode:'hhemp_publish_status'})
      fieldList.push({type:'string',value:'publisher',text:'发布人',dictCode:''})
      fieldList.push({type:'date',value:'publishTime',text:'发布时间'})
      fieldList.push({type:'string',value:'publishApplications',text:'发布应用',dictCode:'hhemp_applications'})
      /*fieldList.push({type:'int',value:'detailNumber',text:'明细数量',dictCode:''})*/
      /*fieldList.push({type:'int',value:'sortNo',text:'排序',dictCode:''})*/
      /*fieldList.push({type:'string',value:'delFlag',text:'刪除标示',dictCode:''})*/
      fieldList.push({type:'string',value:'remark',text:'备注',dictCode:''})
      this.superFieldList = fieldList
    },
    handleContentList(record){
      //this.$router.push({path:'/hhemp/cmsContentTblList', query:{colid:record.id}});

      //this.$refs.listModal.listdetail(record.id);
      this.$parent.tabChange(record.id);
      if(record.topTemplateType == '7' && record.colLevel=='1'){
        this.$parent.appList(record.id)
      }
      if(record.topTemplateType == '9' && record.colLevel=='2'){
        this.$parent.appList(record.id)
      }

    },
    handleApplication(record){
      this.$refs.applicationModel.edit(record);
    },
    publish: function(record){
      var that = this;
      //上架
      this.$confirm({
        title:this.language["emp.col.status.publish"],
        content:this.language["emp.col.status.sureUpShelf"],
        onOk: function(){
          getAction(that.url.publish,{id:record.id,status:'published'}).then((res)=>{
            if(res.success){
              this.$message.success(this.language["operationSuccess"]);
              that.loadData();
              // that.onClearSelected();
            }else{
              this.$message.warn(this.language['common.errorContext'])
            }
          });
        }
      });
    },
    unpublish: function(record){
      var that = this;
      //上架
      this.$confirm({
        title:this.language["emp.col.status.unpublish"],
        content:this.language["emp.col.status.sureDownShelf"],
        onOk: function(){
          getAction(that.url.publish,{id:record.id,status:'unpublished'}).then((res)=>{
            if(res.success){
              this.$message.success(this.language["operationSuccess"]);
              that.loadData();
              // that.onClearSelected();
            }else{
              this.$message.warn(this.language['common.errorContext'])
            }
          });
        }
      });
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
